import { GMO_ERROR_CODE } from "../views/common/gmoErrorcodeConstants";

/**
 * 決済エラーメッセージを取得する
 * @param {string} code
 * @returns {string}
 */
export const getGmoMessageByErroRCode = (code) => {
  if (GMO_ERROR_CODE.E00.CODES.includes(code)) {
    return GMO_ERROR_CODE.E00.MESSAGE;
  } else if (GMO_ERROR_CODE.E01.CODES.includes(code)) {
    return GMO_ERROR_CODE.E01.MESSAGE;
  } else if (GMO_ERROR_CODE.E10.CODES.includes(code)) {
    return GMO_ERROR_CODE.E10.MESSAGE;
  } else if (GMO_ERROR_CODE.E11.CODES.includes(code)) {
    return GMO_ERROR_CODE.E11.MESSAGE;
  } else if (GMO_ERROR_CODE.E41.CODES.includes(code)) {
    return GMO_ERROR_CODE.E41.MESSAGE;
  } else if (GMO_ERROR_CODE.E61.CODES.includes(code)) {
    return GMO_ERROR_CODE.E61.MESSAGE;
  } else if (GMO_ERROR_CODE.E81.CODES.includes(code)) {
    return GMO_ERROR_CODE.E81.MESSAGE;
  } else if (GMO_ERROR_CODE.E90.CODES.includes(code)) {
    return GMO_ERROR_CODE.E90.MESSAGE;
  } else if (GMO_ERROR_CODE.E91.CODES.includes(code)) {
    return GMO_ERROR_CODE.E91.MESSAGE;
  } else if (GMO_ERROR_CODE.E92.CODES.includes(code)) {
    return GMO_ERROR_CODE.E92.MESSAGE;
  } else if (GMO_ERROR_CODE.EX1.CODES.includes(code)) {
    return GMO_ERROR_CODE.EX1.MESSAGE;
  } else if (GMO_ERROR_CODE.C00.CODES.includes(code)) {
    return GMO_ERROR_CODE.C00.MESSAGE;
  } else if (GMO_ERROR_CODE.G02.CODES.includes(code)) {
    return GMO_ERROR_CODE.G02.MESSAGE;
  } else if (GMO_ERROR_CODE.G03.CODES.includes(code)) {
    return GMO_ERROR_CODE.G03.MESSAGE;
  } else if (GMO_ERROR_CODE.G04.CODES.includes(code)) {
    return GMO_ERROR_CODE.G04.MESSAGE;
  } else if (GMO_ERROR_CODE.G06.CODES.includes(code)) {
    return GMO_ERROR_CODE.G06.MESSAGE;
  } else if (GMO_ERROR_CODE.G07.CODES.includes(code)) {
    return GMO_ERROR_CODE.G07.MESSAGE;
  } else if (GMO_ERROR_CODE.G12.CODES.includes(code)) {
    return GMO_ERROR_CODE.G12.MESSAGE;
  } else if (GMO_ERROR_CODE.G42.CODES.includes(code)) {
    return GMO_ERROR_CODE.G42.MESSAGE;
  } else if (GMO_ERROR_CODE.G44.CODES.includes(code)) {
    return GMO_ERROR_CODE.G44.MESSAGE;
  } else if (GMO_ERROR_CODE.G54.CODES.includes(code)) {
    return GMO_ERROR_CODE.G54.MESSAGE;
  } else if (GMO_ERROR_CODE.G65.CODES.includes(code)) {
    return GMO_ERROR_CODE.G65.MESSAGE;
  } else if (GMO_ERROR_CODE.G91.CODES.includes(code)) {
    return GMO_ERROR_CODE.G91.MESSAGE;
  } else if (GMO_ERROR_CODE.M01.CODES.includes(code)) {
    return GMO_ERROR_CODE.M01.MESSAGE;
  } else if (GMO_ERROR_CODE.PP1.CODES.includes(code)) {
    return GMO_ERROR_CODE.PP1.MESSAGE;
  } else if (GMO_ERROR_CODE.LP1.CODES.includes(code)) {
    return GMO_ERROR_CODE.LP1.MESSAGE;
  } else {
    return `処理中にシステムエラーが発生しました。決済は未了です。
    お手数ですが、コールセンターへお問い合わせください。`;
  }
};
